/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { createRangeClass } from '../../factoriesAny.js';
export var RangeDependencies = {
  createRangeClass: createRangeClass
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/es/entry/dependenciesAny/dependenciesRangeClass.generated.js
// module id = 515
// module chunks = 0